(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-new"] && !Shopify.designMode) return;
  try {
    
/**
 * Premium Hero - vanilla JS controller (no dependencies).
 * One instance per [data-premium-hero] section on the page.
 */
(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function PremiumHero(root) {
    this.root = root;
    this.track = root.querySelector('[data-hero-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    this.count = this.slides.length;
    if (!this.count) return;

    this.current = 0;
    this.autoplay = root.dataset.autoplay === 'true' && !REDUCED_MOTION;
    this.autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    this.loop = root.dataset.loop !== 'false';
    this.transitionSpeed = parseInt(root.dataset.transitionSpeed, 10) || 700;
    this.timer = null;
    this.progressRAF = null;

    root.style.setProperty('--t-speed', this.transitionSpeed + 'ms');

    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    this.prevBtn = root.querySelector('[data-hero-prev]');
    this.nextBtn = root.querySelector('[data-hero-next]');
    this.progressBar = root.querySelector('[data-hero-progress-bar]');
    this.fractionCurrent = root.querySelector('[data-hero-fraction-current]');
    this.liveRegion = root.querySelector('[data-hero-live-region]');

    this._bindEvents();
    this._setupIntersectionObserver();
    this._setupCountdowns();
    this._splitHeadings();

    if (this.autoplay && this.count > 1) this._startAutoplay();
  }

  PremiumHero.prototype._bindEvents = function () {
    var self = this;

    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(self.current - 1, 'prev'); self._restartAutoplay(); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(self.current + 1, 'next'); self._restartAutoplay(); });

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { self.go(i); self._restartAutoplay(); });
    });

    // Keyboard navigation
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { self.go(self.current + 1, 'next'); self._restartAutoplay(); }
      if (e.key === 'ArrowLeft') { self.go(self.current - 1, 'prev'); self._restartAutoplay(); }
    });

    // Touch swipe
    var startX = 0, startY = 0, dragging = false;
    this.track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dragging = true;
    }, { passive: true });
    this.track.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) self.go(self.current + 1, 'next'); else self.go(self.current - 1, 'prev');
        self._restartAutoplay();
      }
    }, { passive: true });

    // Pause autoplay on hover / focus for accessibility
    this.root.addEventListener('mouseenter', function () { self._pauseAutoplay(); });
    this.root.addEventListener('mouseleave', function () { if (self.autoplay) self._startAutoplay(); });
    this.root.addEventListener('focusin', function () { self._pauseAutoplay(); });
    this.root.addEventListener('focusout', function () { if (self.autoplay) self._startAutoplay(); });

    // Video play/pause toggle buttons
    this.root.querySelectorAll('[data-hero-video-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var video = btn.parentElement.querySelector('[data-hero-video]');
        if (!video) return;
        if (video.paused) { video.play(); btn.dataset.paused = 'false'; }
        else { video.pause(); btn.dataset.paused = 'true'; }
      });
    });
  };

  PremiumHero.prototype.go = function (index, dir) {
    if (this.count <= 1) return;
    var next = index;
    if (this.loop) {
      next = (index + this.count) % this.count;
    } else {
      next = Math.max(0, Math.min(this.count - 1, index));
    }
    if (next === this.current) return;

    var prevSlide = this.slides[this.current];
    var nextSlide = this.slides[next];

    prevSlide.classList.remove('is-active');
    prevSlide.classList.add(dir === 'prev' ? 'is-next' : 'is-prev');
    prevSlide.setAttribute('hidden', '');

    nextSlide.removeAttribute('hidden');
    // force reflow so the transition class change animates
    void nextSlide.offsetWidth;
    nextSlide.classList.add('is-active');

    var self = this;
    window.setTimeout(function () {
      prevSlide.classList.remove('is-prev', 'is-next');
    }, this.transitionSpeed);

    this.current = next;
    this._syncUI();
    this._playActiveMedia();
    this._resetProgress();

    if (this.liveRegion) {
      this.liveRegion.textContent = 'Slide ' + (next + 1) + ' of ' + this.count;
    }
  };

  PremiumHero.prototype._syncUI = function () {
    this.dots.forEach(function (dot, i) {
      var active = i === this.current;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
    }, this);

    if (this.fractionCurrent) {
      this.fractionCurrent.textContent = String(this.current + 1).padStart(2, '0');
    }
  };

  PremiumHero.prototype._startAutoplay = function () {
    if (this.count <= 1 || REDUCED_MOTION) return;
    this._pauseAutoplay();
    var self = this;
    this.timer = window.setInterval(function () {
      self.go(self.current + 1, 'next');
    }, this.autoplaySpeed);
    this._animateProgress();
  };

  PremiumHero.prototype._pauseAutoplay = function () {
    if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
    if (this.progressRAF) { window.cancelAnimationFrame(this.progressRAF); this.progressRAF = null; }
  };

  PremiumHero.prototype._restartAutoplay = function () {
    if (this.autoplay) this._startAutoplay();
  };

  PremiumHero.prototype._resetProgress = function () {
    if (!this.progressBar) return;
    this.progressBar.style.transition = 'none';
    this.progressBar.style.width = '0%';
    if (this.autoplay) {
      void this.progressBar.offsetWidth;
      this._animateProgress();
    }
  };

  PremiumHero.prototype._animateProgress = function () {
    if (!this.progressBar) return;
    var start = performance.now();
    var duration = this.autoplaySpeed;
    var self = this;
    function step(now) {
      var pct = Math.min(100, ((now - start) / duration) * 100);
      self.progressBar.style.width = pct + '%';
      if (pct < 100 && self.timer) {
        self.progressRAF = window.requestAnimationFrame(step);
      }
    }
    this.progressRAF = window.requestAnimationFrame(step);
  };

  /* Lazy-load & autoplay video/embeds only when the slide is in view */
  PremiumHero.prototype._setupIntersectionObserver = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) {
      this._loadAllMedia();
      return;
    }
    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) self._loadSlideMedia(entry.target);
      });
    }, { threshold: 0.25 });

    this.slides.forEach(function (slide) { self.observer.observe(slide); });
    // Always eagerly prep the first (active) slide's media.
    this._loadSlideMedia(this.slides[0]);
  };

  PremiumHero.prototype._loadAllMedia = function () {
    var self = this;
    this.slides.forEach(function (slide) { self._loadSlideMedia(slide); });
  };

  PremiumHero.prototype._loadSlideMedia = function (slide) {
    var video = slide.querySelector('[data-hero-video]');
    if (video && !video.dataset.loaded) {
      var source = video.querySelector('source[data-src]');
      if (source) { source.src = source.dataset.src; video.load(); }
      video.dataset.loaded = 'true';
      if (slide.classList.contains('is-active')) this._playVideo(video);
    }

    var embed = slide.querySelector('[data-hero-embed]');
    if (embed && !embed.dataset.loaded) {
      this._loadEmbed(embed);
      embed.dataset.loaded = 'true';
    }
  };

  PremiumHero.prototype._loadEmbed = function (embed) {
    var type = embed.dataset.embed;
    var id = embed.dataset.videoId;
    var autoplay = embed.dataset.autoplay === 'true' && !REDUCED_MOTION ? 1 : 0;
    var loop = embed.dataset.loop === 'true' ? 1 : 0;
    var iframe = document.createElement('iframe');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('title', 'Background video');
    if (type === 'youtube') {
      iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=' + autoplay + '&mute=1&loop=' + loop + '&playlist=' + id + '&controls=0&modestbranding=1&playsinline=1';
    } else if (type === 'vimeo') {
      iframe.src = 'https://player.vimeo.com/video/' + id + '?autoplay=' + autoplay + '&muted=1&loop=' + loop + '&background=1';
    }
    embed.appendChild(iframe);
  };

  PremiumHero.prototype._playActiveMedia = function () {
    var activeSlide = this.slides[this.current];
    var video = activeSlide.querySelector('[data-hero-video]');
    if (video) this._playVideo(video);

    // pause videos in inactive slides to save resources
    this.slides.forEach(function (slide) {
      if (slide === activeSlide) return;
      var v = slide.querySelector('[data-hero-video]');
      if (v && !v.paused) v.pause();
    });
  };

  PremiumHero.prototype._playVideo = function (video) {
    if (video.dataset.autoplay === 'false' || REDUCED_MOTION) return;
    var playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () { /* autoplay blocked, user can use toggle */ });
  };

  /* Countdown timers */
  PremiumHero.prototype._setupCountdowns = function () {
    var timers = this.root.querySelectorAll('[data-countdown]');
    timers.forEach(function (el) {
      var target = new Date(el.dataset.target).getTime();
      if (isNaN(target)) return;
      function update() {
        var diff = Math.max(0, target - Date.now());
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var dayEl = el.querySelector('[data-countdown-days]');
        var hourEl = el.querySelector('[data-countdown-hours]');
        var minEl = el.querySelector('[data-countdown-minutes]');
        var secEl = el.querySelector('[data-countdown-seconds]');
        if (dayEl) dayEl.textContent = String(d).padStart(2, '0');
        if (hourEl) hourEl.textContent = String(h).padStart(2, '0');
        if (minEl) minEl.textContent = String(m).padStart(2, '0');
        if (secEl) secEl.textContent = String(s).padStart(2, '0');
        if (diff <= 0) window.clearInterval(interval);
      }
      update();
      var interval = window.setInterval(update, 1000);
    });
  };

  /* Letter-reveal animation: split heading text into spans (skips if reduced motion) */
  PremiumHero.prototype._splitHeadings = function () {
    if (REDUCED_MOTION) return;
    var headings = this.root.querySelectorAll('[data-split-text="true"]');
    headings.forEach(function (heading) {
      var text = heading.textContent;
      var frag = document.createDocumentFragment();
      Array.prototype.forEach.call(text, function (ch, i) {
        var span = document.createElement('span');
        span.className = 'hero-char';
        span.style.animationDelay = (i * 22) + 'ms';
        span.textContent = ch === ' ' ? '\u00A0' : ch;
        frag.appendChild(span);
      });
      heading.textContent = '';
      heading.appendChild(frag);
    });
  };

  /* Scroll progress circle indicator (fills as user scrolls past the hero) */
  function bindScrollIndicator(root) {
    var indicator = root.querySelector('[data-hero-scroll-indicator]');
    if (!indicator) return;

    indicator.addEventListener('click', function () {
      var next = root.nextElementSibling;
      (next || root).scrollIntoView({ behavior: REDUCED_MOTION ? 'auto' : 'smooth' });
    });
    indicator.style.cursor = 'pointer';

    var circleBar = indicator.querySelector('.hero-scroll-circle__bar');
    if (!circleBar) return;
    var circumference = 107;
    function onScroll() {
      var rect = root.getBoundingClientRect();
      var progress = Math.min(1, Math.max(0, -rect.top / (rect.height || 1)));
      circleBar.style.strokeDashoffset = String(circumference * (1 - progress));
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    document.documentElement.classList.remove('no-js');
    document.querySelectorAll('[data-premium-hero]').forEach(function (root) {
      new PremiumHero(root);
      bindScrollIndicator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify theme editor injects/updates the section
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-premium-hero]');
    if (root) { new PremiumHero(root); bindScrollIndicator(root); }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-hero-section"] && !Shopify.designMode) return;
  try {
    
/**
 * Premium Hero — vanilla JS controller (no dependencies).
 * One instance per [data-premium-hero] section on the page.
 */
(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function PremiumHero(root) {
    this.root = root;
    this.track = root.querySelector('[data-hero-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    this.count = this.slides.length;
    if (!this.count) return;

    this.current = 0;
    this.autoplay = root.dataset.autoplay === 'true' && !REDUCED_MOTION;
    this.autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    this.loop = root.dataset.loop !== 'false';
    this.transitionSpeed = parseInt(root.dataset.transitionSpeed, 10) || 700;
    this.timer = null;
    this.progressRAF = null;

    root.style.setProperty('--t-speed', this.transitionSpeed + 'ms');

    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    this.prevBtn = root.querySelector('[data-hero-prev]');
    this.nextBtn = root.querySelector('[data-hero-next]');
    this.progressBar = root.querySelector('[data-hero-progress-bar]');
    this.fractionCurrent = root.querySelector('[data-hero-fraction-current]');
    this.liveRegion = root.querySelector('[data-hero-live-region]');

    this._bindEvents();
    this._setupIntersectionObserver();
    this._setupCountdowns();
    this._splitHeadings();

    if (this.autoplay && this.count > 1) this._startAutoplay();
  }

  PremiumHero.prototype._bindEvents = function () {
    var self = this;

    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(self.current - 1, 'prev'); self._restartAutoplay(); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(self.current + 1, 'next'); self._restartAutoplay(); });

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { self.go(i); self._restartAutoplay(); });
    });

    // Keyboard navigation
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { self.go(self.current + 1, 'next'); self._restartAutoplay(); }
      if (e.key === 'ArrowLeft') { self.go(self.current - 1, 'prev'); self._restartAutoplay(); }
    });

    // Touch swipe
    var startX = 0, startY = 0, dragging = false;
    this.track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dragging = true;
    }, { passive: true });
    this.track.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) self.go(self.current + 1, 'next'); else self.go(self.current - 1, 'prev');
        self._restartAutoplay();
      }
    }, { passive: true });

    // Pause autoplay on hover / focus for accessibility
    this.root.addEventListener('mouseenter', function () { self._pauseAutoplay(); });
    this.root.addEventListener('mouseleave', function () { if (self.autoplay) self._startAutoplay(); });
    this.root.addEventListener('focusin', function () { self._pauseAutoplay(); });
    this.root.addEventListener('focusout', function () { if (self.autoplay) self._startAutoplay(); });

    // Video play/pause toggle buttons
    this.root.querySelectorAll('[data-hero-video-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var video = btn.parentElement.querySelector('[data-hero-video]');
        if (!video) return;
        if (video.paused) { video.play(); btn.dataset.paused = 'false'; }
        else { video.pause(); btn.dataset.paused = 'true'; }
      });
    });
  };

  PremiumHero.prototype.go = function (index, dir) {
    if (this.count <= 1) return;
    var next = index;
    if (this.loop) {
      next = (index + this.count) % this.count;
    } else {
      next = Math.max(0, Math.min(this.count - 1, index));
    }
    if (next === this.current) return;

    var prevSlide = this.slides[this.current];
    var nextSlide = this.slides[next];

    prevSlide.classList.remove('is-active');
    prevSlide.classList.add(dir === 'prev' ? 'is-next' : 'is-prev');
    prevSlide.setAttribute('hidden', '');

    nextSlide.removeAttribute('hidden');
    // force reflow so the transition class change animates
    void nextSlide.offsetWidth;
    nextSlide.classList.add('is-active');

    var self = this;
    window.setTimeout(function () {
      prevSlide.classList.remove('is-prev', 'is-next');
    }, this.transitionSpeed);

    this.current = next;
    this._syncUI();
    this._playActiveMedia();
    this._resetProgress();

    if (this.liveRegion) {
      this.liveRegion.textContent = 'Slide ' + (next + 1) + ' of ' + this.count;
    }
  };

  PremiumHero.prototype._syncUI = function () {
    this.dots.forEach(function (dot, i) {
      var active = i === this.current;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
    }, this);

    if (this.fractionCurrent) {
      this.fractionCurrent.textContent = String(this.current + 1).padStart(2, '0');
    }
  };

  PremiumHero.prototype._startAutoplay = function () {
    if (this.count <= 1 || REDUCED_MOTION) return;
    this._pauseAutoplay();
    var self = this;
    this.timer = window.setInterval(function () {
      self.go(self.current + 1, 'next');
    }, this.autoplaySpeed);
    this._animateProgress();
  };

  PremiumHero.prototype._pauseAutoplay = function () {
    if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
    if (this.progressRAF) { window.cancelAnimationFrame(this.progressRAF); this.progressRAF = null; }
  };

  PremiumHero.prototype._restartAutoplay = function () {
    if (this.autoplay) this._startAutoplay();
  };

  PremiumHero.prototype._resetProgress = function () {
    if (!this.progressBar) return;
    this.progressBar.style.transition = 'none';
    this.progressBar.style.width = '0%';
    if (this.autoplay) {
      void this.progressBar.offsetWidth;
      this._animateProgress();
    }
  };

  PremiumHero.prototype._animateProgress = function () {
    if (!this.progressBar) return;
    var start = performance.now();
    var duration = this.autoplaySpeed;
    var self = this;
    function step(now) {
      var pct = Math.min(100, ((now - start) / duration) * 100);
      self.progressBar.style.width = pct + '%';
      if (pct < 100 && self.timer) {
        self.progressRAF = window.requestAnimationFrame(step);
      }
    }
    this.progressRAF = window.requestAnimationFrame(step);
  };

  /* Lazy-load & autoplay video/embeds only when the slide is in view */
  PremiumHero.prototype._setupIntersectionObserver = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) {
      this._loadAllMedia();
      return;
    }
    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) self._loadSlideMedia(entry.target);
      });
    }, { threshold: 0.25 });

    this.slides.forEach(function (slide) { self.observer.observe(slide); });
    // Always eagerly prep the first (active) slide's media.
    this._loadSlideMedia(this.slides[0]);
  };

  PremiumHero.prototype._loadAllMedia = function () {
    var self = this;
    this.slides.forEach(function (slide) { self._loadSlideMedia(slide); });
  };

  PremiumHero.prototype._loadSlideMedia = function (slide) {
    var video = slide.querySelector('[data-hero-video]');
    if (video && !video.dataset.loaded) {
      var source = video.querySelector('source[data-src]');
      if (source) { source.src = source.dataset.src; video.load(); }
      video.dataset.loaded = 'true';
      if (slide.classList.contains('is-active')) this._playVideo(video);
    }

    var embed = slide.querySelector('[data-hero-embed]');
    if (embed && !embed.dataset.loaded) {
      this._loadEmbed(embed);
      embed.dataset.loaded = 'true';
    }
  };

  PremiumHero.prototype._loadEmbed = function (embed) {
    var type = embed.dataset.embed;
    var id = embed.dataset.videoId;
    var autoplay = embed.dataset.autoplay === 'true' && !REDUCED_MOTION ? 1 : 0;
    var loop = embed.dataset.loop === 'true' ? 1 : 0;
    var iframe = document.createElement('iframe');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('title', 'Background video');
    if (type === 'youtube') {
      iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=' + autoplay + '&mute=1&loop=' + loop + '&playlist=' + id + '&controls=0&modestbranding=1&playsinline=1';
    } else if (type === 'vimeo') {
      iframe.src = 'https://player.vimeo.com/video/' + id + '?autoplay=' + autoplay + '&muted=1&loop=' + loop + '&background=1';
    }
    embed.appendChild(iframe);
  };

  PremiumHero.prototype._playActiveMedia = function () {
    var activeSlide = this.slides[this.current];
    var video = activeSlide.querySelector('[data-hero-video]');
    if (video) this._playVideo(video);

    // pause videos in inactive slides to save resources
    this.slides.forEach(function (slide) {
      if (slide === activeSlide) return;
      var v = slide.querySelector('[data-hero-video]');
      if (v && !v.paused) v.pause();
    });
  };

  PremiumHero.prototype._playVideo = function (video) {
    if (video.dataset.autoplay === 'false' || REDUCED_MOTION) return;
    var playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () { /* autoplay blocked, user can use toggle */ });
  };

  /* Countdown timers */
  PremiumHero.prototype._setupCountdowns = function () {
    var timers = this.root.querySelectorAll('[data-countdown]');
    timers.forEach(function (el) {
      var target = new Date(el.dataset.target).getTime();
      if (isNaN(target)) return;
      function update() {
        var diff = Math.max(0, target - Date.now());
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var dayEl = el.querySelector('[data-countdown-days]');
        var hourEl = el.querySelector('[data-countdown-hours]');
        var minEl = el.querySelector('[data-countdown-minutes]');
        var secEl = el.querySelector('[data-countdown-seconds]');
        if (dayEl) dayEl.textContent = String(d).padStart(2, '0');
        if (hourEl) hourEl.textContent = String(h).padStart(2, '0');
        if (minEl) minEl.textContent = String(m).padStart(2, '0');
        if (secEl) secEl.textContent = String(s).padStart(2, '0');
        if (diff <= 0) window.clearInterval(interval);
      }
      update();
      var interval = window.setInterval(update, 1000);
    });
  };

  /* Letter-reveal animation: split heading text into spans (skips if reduced motion) */
  PremiumHero.prototype._splitHeadings = function () {
    if (REDUCED_MOTION) return;
    var headings = this.root.querySelectorAll('[data-split-text="true"]');
    headings.forEach(function (heading) {
      var text = heading.textContent;
      var frag = document.createDocumentFragment();
      Array.prototype.forEach.call(text, function (ch, i) {
        var span = document.createElement('span');
        span.className = 'hero-char';
        span.style.animationDelay = (i * 22) + 'ms';
        span.textContent = ch === ' ' ? '\u00A0' : ch;
        frag.appendChild(span);
      });
      heading.textContent = '';
      heading.appendChild(frag);
    });
  };

  /* Scroll progress circle indicator (fills as user scrolls past the hero) */
  function bindScrollIndicator(root) {
    var indicator = root.querySelector('[data-hero-scroll-indicator]');
    if (!indicator) return;

    indicator.addEventListener('click', function () {
      var next = root.nextElementSibling;
      (next || root).scrollIntoView({ behavior: REDUCED_MOTION ? 'auto' : 'smooth' });
    });
    indicator.style.cursor = 'pointer';

    var circleBar = indicator.querySelector('.hero-scroll-circle__bar');
    if (!circleBar) return;
    var circumference = 107;
    function onScroll() {
      var rect = root.getBoundingClientRect();
      var progress = Math.min(1, Math.max(0, -rect.top / (rect.height || 1)));
      circleBar.style.strokeDashoffset = String(circumference * (1 - progress));
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    document.documentElement.classList.remove('no-js');
    document.querySelectorAll('[data-premium-hero]').forEach(function (root) {
      new PremiumHero(root);
      bindScrollIndicator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify theme editor injects/updates the section
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-premium-hero]');
    if (root) { new PremiumHero(root); bindScrollIndicator(root); }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
